import { render, staticRenderFns } from "./CommentContent.vue?vue&type=template&id=3c7a1271&scoped=true&"
import script from "./CommentContent.vue?vue&type=script&lang=js&"
export * from "./CommentContent.vue?vue&type=script&lang=js&"
import style0 from "./CommentContent.vue?vue&type=style&index=0&id=3c7a1271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a1271",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c7a1271')) {
      api.createRecord('3c7a1271', component.options)
    } else {
      api.reload('3c7a1271', component.options)
    }
    module.hot.accept("./CommentContent.vue?vue&type=template&id=3c7a1271&scoped=true&", function () {
      api.rerender('3c7a1271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/CommentContent.vue"
export default component.exports